import { Typography,Grid2 } from '@mui/material'
import React from 'react'
import "../Contact.css"
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';

export function ContactLocationMobile() {
  return (
   <>
   <Grid2 className="contact-details info" gap="30px" marginTop="10px" flexWrap="wrap"> 
    <Grid2 className="details" width="95% !important" gap="10px" >
        {/* <span className="headerdata">GET IN TOUCH</span> */}
        <Typography className="getintouch" variant='h2'>Registered Address:</Typography>
        {/* <Typography className="HeadOffice" variant='h3'>Head Office</Typography> */}
        <Grid2 container gap="10px" flexDirection="column"  >
            <Grid2 container gap="10px">
                <LocationOnIcon/>
                <Typography> Grow Beyond Global Business Pvt. Ltd.<br/>HIVE, 4th Floor, Vasista Bhavan,<br/> opp. lane to, DLF Cyber City,  <br/> Indira Nagar,Gachibowli, <br/>  Hyderabad, Telangana 500032</Typography>
            </Grid2>
            <Grid2 container gap="10px">
                <EmailIcon/>
                <Typography>sales@growbeyondglobal.com</Typography>
            </Grid2>
            <Grid2 container gap="10px">
                <CallIcon/>
                <Typography>+91-76758 09054</Typography>
            </Grid2>
        </Grid2>
    </Grid2>
    <Grid2 className="map" width="95% !important">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d951.550564029035!2d78.35521907045342!3d17.45003097423947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9337142d0d05%3A0xacab10a405438a92!2sANSUM%20Technologies!5e0!3m2!1sen!2sin!4v1741852040744!5m2!1sen!2sin" width="600" height="450" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </Grid2>
</Grid2>
   </>
  )
}

 